const ProcessAndPolitics = () => {
  return (
    <div>
      <h1>Process and Politics</h1>
      <p>lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
    </div>
  );
};

export default ProcessAndPolitics;
